// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--Havpv","content-wrapper":"_93444fe79c--content-wrapper--pPBmj"};